<header
	class="bg-charcoal flex h-12 shrink-0 items-center justify-between px-4 text-white dark:text-[#d4d4d4]"
>
	<span class="text-lg font-bold">Hellō Quickstart</span>
	<ul>
		<li>
			<a
				href="https://www.hello.dev/docs/"
				target="_blank"
				class="inline-flex items-center text-sm"
			>
				<span>Documentation</span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="ml-1 h-4 opacity-80"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
					stroke-width="2"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
					/>
				</svg>
			</a>
		</li>
	</ul>
</header>
